import { debounce } from '@repo/utils/debounce'
import { storeWrapper } from '../storeWrapper'
import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'
import { useFeeEarnerStore } from '@repo/store/useFeeEarnerStore'
import { useKeyDateStore } from '@repo/store/useKeyDateStore'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import { useTimeRecordingStore } from '@repo/store/useTimeRecordingStore'
import { useUndertakingsStore } from '@repo/store/useUndertakingsStore'
import { useUserPreferencesStore } from '@repo/store/useUserPreferencesStore'

const initialState = {}

export const useInitialDataFetchStore = storeWrapper('useInitialDataFetch', (set) => ({
  ...initialState,
  fetchInitialData: async () => {
    const { fetchEmailSubscriptionEmailAddressByCurrentUser } = useAuthenticationStore.getState()
    const { fetchFeeEarners } = useFeeEarnerStore.getState()
    const { fetchKeyDateLocations, fetchKeyDateTypes } = useKeyDateStore.getState()
    const {
      fetchBranches,
      fetchDepartments,
      fetchExpertiseAreas,
      fetchExpertTypes,
      fetchMatterHistoryTypes,
      fetchPhoneTypes,
      fetchRetentionPolicies,
      fetchWorkflowTypes,
      fetchOspreyStartupConfiguration,
      fetchEnableBundledocs,
      fetchEnableAutomatedBankReconciliation
    } = useLookupsStore.getState()
    const { fetchTimeUnitType } = useTimeRecordingStore.getState()
    const { fetchIsUndertakingsSupported } = useUndertakingsStore.getState()
    const { fetchUserPreferences } = useUserPreferencesStore.getState()

    debounce({
      id: 'fetchInitialData-fetchLookups',
      delay: 1000,
      callback: async () => {
        try {
          await Promise.all([
            fetchBranches(),
            fetchDepartments(),
            fetchExpertiseAreas(),
            fetchExpertTypes(),
            fetchFeeEarners(),
            fetchMatterHistoryTypes(),
            fetchKeyDateLocations(),
            fetchKeyDateTypes({ startAtIndex: 0, pageSize: 50 }),
            fetchOspreyStartupConfiguration(),
            fetchEnableBundledocs(),
            fetchEnableAutomatedBankReconciliation(),
            fetchPhoneTypes(),
            fetchRetentionPolicies(),
            fetchTimeUnitType(),
            fetchIsUndertakingsSupported(),
            fetchUserPreferences(),
            fetchWorkflowTypes(),
            fetchEmailSubscriptionEmailAddressByCurrentUser(),
          ])
        } catch (error) {
          console.error('Error fetching initial data:', error)
        }
      }
    })
  },
  reset: () => set(initialState)
}))
